import { render, staticRenderFns } from "./managePup.vue?vue&type=template&id=8cfc6e4a&scoped=true&"
import script from "./managePup.vue?vue&type=script&lang=js&"
export * from "./managePup.vue?vue&type=script&lang=js&"
import style0 from "./managePup.vue?vue&type=style&index=0&id=8cfc6e4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfc6e4a",
  null
  
)

export default component.exports